// 音效组合式函数（按键音已全部禁用）
export function useSound() {
  const playClick = () => {}
  const playSuccess = () => {}
  const playError = () => {}
  const withSound = (fn) => {
    return (...args) => {
      if (typeof fn === 'function') {
        return fn(...args)
      }
    }
  }

  return {
    playClick,
    playSuccess,
    playError,
    withSound
  }
}

